<template>
  <div>
    <div v-if="dataError.length === 0" class="importStaffStepOne">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Thêm danh sách Ticket từ file</h1>
        <div class="btn-group float-right">
          <router-link class="f12 font-medium btn btn-outline-secondary" :to="`/leads`">
            <i class="bx bx-arrow-back"></i> Quay lại
          </router-link>
        </div>
      </div>

      <div class="card p-10 pt-15 b-t-1-869fb229">
        <div class="card-body">
          <div class="step-content">
            <div class="step-upfile">
              <section class="open-input">
                <div class="oi-alert">
                  <span v-show="keyCheckUpload === 0" style="width: 80px; display: inline-block"
                    ><img src="@/assets/img/upload.svg" alt=""
                  /></span>
                  <span v-show="keyCheckUpload === 1" style="width: 80px; display: inline-block"
                    ><img src="@/assets/img/upload-thanhcong.svg" alt=""
                  /></span>
                  <span v-show="keyCheckUpload === 2" style="width: 80px; display: inline-block"
                    ><img src="@/assets/img/upload-thatbai.svg" alt=""
                  /></span>
                </div>

                <div class="input-file-container" style="width: 150px">
                  <input
                    class="input-file"
                    style="display: none"
                    id="my-file"
                    @change="uploadFileExcel"
                    type="file"
                  />
                  <label tabindex="0" for="my-file" class="btn btn-outline-secondary"
                    >Chọn file tải lên</label
                  >
                </div>
                <p v-if="this.messFailFormat != ''" style="color: red">
                  {{ this.messFailFormat }}
                </p>
              </section>
              <p class="text-primary font-size-20 mb-3">{{ fileName }}</p>
              <p>Hỗ trợ các tệp có định dạng *.xls, *.xlsx, *.csv, *.ods</p>
              <button type="button" @click="downloadFileTemplateExcel()" class="btn">
                <i class="bx bx-archive-in"></i> Tải file mẫu
              </button>
            </div>

            <div class="step-upfooter">
              <button
                type="button"
                class="btn btn-primary btn-lg"
                style="width: 100%"
                @click="submitUpload()"
              >
                Xác nhận
              </button>
            </div>
            <div class="history-file table-responsive m-t-20">
              <h3 class="m-b-10">File của bạn</h3>
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Thời gian import</th>
                    <th>Tên file</th>
                    <th>Trạng thái</th>
                    <th>Kết quả</th>
                    <th>Hành động</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in dataHistoryUpload" :key="index">
                  <tr>
                    <td>{{ item.importAt | formatDate('HH:mm DD/MM/YYYY') }}</td>
                    <td>
                      <a href="#">{{ item.fileName }}</a>
                    </td>
                    <td>{{ item.status | transformData(statusOption) }}</td>
                    <td>
                      <p>Thành công: {{ item.recordSuccess }}</p>
                      <p>Thất bại: {{ item.recordFailed }}</p>
                    </td>
                    <td>
                      <button
                        class="f12 font-medium btn btn-outline-secondary"
                        @click="dowloadFileError(item.fileId)"
                      >
                        Tải file báo lỗi
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    </div>
    <modalProcessingUploadTicket ref="uploadNotif" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { TicketService } from '../../services/ticket.service'
  import modalProcessingUploadTicket from './modal-processing-upload-ticket.vue'

  export default {
    data() {
      return {
        messFailFormat: '',
        keyCheckUpload: 0,
        formData: null,
        fileName: null,
        showLoading: false,
        dataError: [],
        countItemErr: null,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataHistoryUpload: [],
        statusOption: [
          { id: 'SUCCESS', text: 'Hoàn thành' },
          { id: 'ERROR', text: 'Thất bại' },
        ],
      }
    },
    components: { modalProcessingUploadTicket },
    created() {
      this.getHistoryUpload()
    },

    methods: {
      async downloadFileTemplateExcel() {
        try {
          this.showLoading = true
          await TicketService.downloadFileTemplate()
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async closeImport() {
        this.$router.push('/ticket')
      },

      async uploadFileExcel(file) {
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)

        const fileData = file.target.files[0]

        if (fileData.size > 20 * 1024 * 1024) {
          alert('File tối đa 20MB')
          return
        }

        this.fileName = fileData.name
        this.messFailFormat = ''
        this.keyCheckUpload = 1
        this.formData = new FormData()
        this.formData.append('file', fileData)
        this.formData.append('urlFile', file.target.files[0].name)

        if (!checkFomat) {
          this.keyCheckUpload = 2
          this.messFailFormat = 'Định dạng không hợp lệ !'
          this.fileName = null
        }
      },

      async submitUpload() {
        try {
          this.showLoading = true
          if (this.formData === null) {
            this.messFailFormat = 'Vui lòng chọn file tải lên !'
            return
          }
          const data = await TicketService.importTicketByExcel(this.formData)

          if (data.code === 1000) {
            this.openModalLoadFile(data.data.fileId)
          } else if (data.code === 1020 || data.code === 1007) {
            this.showFailMx(
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
            )
          } else if (data.code === 1021 || data.code === 1040) {
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },

      reselect() {
        this.dataError = []
        this.fileName = null
        this.formData = null
      },
      async getHistoryUpload() {
        const body = {
          limit: 20,
          page: 1,
        }
        const dataResponse = await TicketService.historyUpload(body)

        if (dataResponse.code === 1000) {
          this.dataHistoryUpload = dataResponse.data
        }
      },
      async dowloadFileError(id) {
        try {
          this.showLoading = true
          await TicketService.dowloadFileError({ id })
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
  }
</script>
